import type { ApiFlow } from '../types'

export const nativeBrowserPkceFlow: ApiFlow = {
  id: 'native.browser-pkce',
  appTypes: ['native'],
  title: 'System browser OAuth (PKCE)',
  summary:
    'Open the system browser for authorize, deep-link back to your app with the code, then exchange at the token endpoint.',
  steps: [
    {
      id: 'authorize',
      title: 'Open authorize URL',
      when: 'User taps Sign in',
      method: 'GET',
      path: '/oauth2/auth',
      query: {
        response_type: 'code',
        client_id: '{{CLIENT_ID}}',
        redirect_uri: '{{REDIRECT_URI}}',
        scope: 'openid profile',
        code_challenge: '<s256-challenge>',
        code_challenge_method: 'S256',
        state: '<csrf-state>',
      },
      responseVariants: [
        {
          label: 'deep link callback',
          status: 302,
          body: { note: 'App receives {{REDIRECT_URI}}?code=...&state=... via deep link' },
          nextStepId: 'token',
        },
      ],
    },
    {
      id: 'token',
      title: 'Exchange code',
      when: 'Deep link delivers code',
      method: 'POST',
      path: '/oauth2/token',
      requestBody: {
        grant_type: 'authorization_code',
        code: '<code>',
        redirect_uri: '{{REDIRECT_URI}}',
        client_id: '{{CLIENT_ID}}',
        code_verifier: '<verifier>',
      },
      responseVariants: [
        {
          label: 'success',
          status: 200,
          body: { access_token: 'eyJ...', refresh_token: '...', id_token: 'eyJ...' },
        },
      ],
    },
  ],
}
